<template>
	<a :class="['menuToggle', {show}]" @click.stop="toggle" />
	<div
		v-show="show"
		ref="menu"
		class="toggle"
		tabindex="-1"
		@blur="blurred"
	>
		<ul class="itemTileMenu">  
			<slot :hide="hide" />
		</ul>
	</div>
</template>

<script>
import { nextTick } from "vue";
export default {
	data() {
		return {
			show: false,
			preventShow: false,
		};
	},
	methods: {
		blurred() {
			this.show = false;
			this.preventShow = true;
			setTimeout(() => (this.preventShow = false), 200);
		},
		toggle() {
			if (!this.preventShow) {
				this.show = true;
				nextTick(() => this.$refs.menu.focus());
			}
		},
		hide() {
			this.$refs.menu.blur();
		},
	},
};
</script>
